import { finish, error } from '../../../modules/bets/actions/park-bet';
import api from '../../../api';

export function request(dispatch, { id, accountId, status }) {
    api.request(status ? 'POST' : 'DELETE', '/bets/' + id + '/parking', { data: { accountId } }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
